// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from '@services/route-guard.service';
import { UserService } from '@services/user.service';

@Injectable({
    providedIn: 'root',
})
export class NewUserGuard implements CanActivate {
    constructor(
        private readonly userService: UserService,
        private readonly routeGuardService: RouteGuardService
    ) {}

    canActivate(): boolean {
        const canActivateEvaluation = this.userService.user.sendToWelcomeFlow;
        this.routeGuardService.logRouteGuard(this.constructor.name, canActivateEvaluation);
        return canActivateEvaluation;
    }
}
